import PropTypes from 'prop-types';

import { ListItemText } from '@mui/material';
import { format, formatDistanceToNow } from 'date-fns';
import { useTranslation } from '../LocalizationProvider';

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy HH:mm');
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true
  });
}

export function timeForm(time) {
  let hours;
  let minute;
  time /= 60000;
  if (Math.floor(time / 60) >= 0 && Math.floor(time / 60) <= 9) {
    hours = `000${Math.floor(time / 60).toString()}`;
  } else if (Math.floor(time / 60) > 9 && Math.floor(time / 60) < 100) {
    hours = `00${Math.floor(time / 60)}`;
  } else if (Math.floor(time / 60) >= 100 && Math.floor(time / 60) < 1000) {
    hours = `0${Math.floor(time / 60)}`;
  } else {
    hours = `${Math.floor(time / 60)}`;
  }
  if (Math.floor(time % 60) >= 0 && Math.floor(time % 60) <= 9) {
    minute = `0${Math.floor(time % 60)}`;
  } else {
    minute = `${Math.floor(time % 60)}`;
  }
  return `${hours}:${minute}`;
}

export function timeMs(time) {
  const index = time.indexOf(':');

  return (Math.round(time.slice(index + 1, 7)) + Math.round(time.slice(0, index)) * 60) * 60000;
}

LastUpdateFormatter.propTypes = {
  device: PropTypes.object
};

export default function LastUpdateFormatter({ device }) {
  const t = useTranslation();
  let seconds;
  let secondary;
  const value = new Date(device.lastUpdate);
  if (value) {
    seconds = Math.floor((new Date() - value) / 1000);
    if (seconds < 0) seconds = 0;
    if (Math.floor(seconds / 86400) >= 1 && Math.floor(seconds / 86400) < 2)
      secondary = `${Math.floor(seconds / 86400)} ${t('LM_DayAgo')}`;
    else if (Math.floor(seconds / 86400) > 2)
      secondary = `${Math.floor(seconds / 86400)} ${t('LM_DaysAgo')}`;
    else if (Math.floor(seconds / 3600) >= 1 && Math.floor(seconds / 3600) < 2)
      secondary = `${Math.floor(seconds / 3600)} ${t('LM_HourAgo')}`;
    else if (Math.floor(seconds / 3600) > 2)
      secondary = `${Math.floor(seconds / 3600)} ${t('LM_HoursAgo')}`;
    else if (Math.floor(seconds / 60) >= 1 && Math.floor(seconds / 60) < 2)
      secondary = `${Math.floor(seconds / 60)} ${t('LM_MinuteAgo')}`;
    else secondary = `${Math.floor(seconds / 60)} ${t('LM_MinutesAgo')}`;
  }

  return <ListItemText primary={device.name} secondary={device.status !== 'online' && secondary} />;
}
